// extracted by mini-css-extract-plugin
export default {"cont":"Details_cont__A4Cw9","details":"Details_details__KClfC","buttonCont":"Details_buttonCont__k+l9W"};